module.exports = __webpack_public_path__ + "img/write-neopload-banner.4cf7031c.jpeg";